import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { AUTH_TOKEN } from "constants/AuthConstant";
import APKFAS1SlicesService from "services/Setup/LoanOrigination/APKFAS1/APKFAS1Service";
import { notification } from "antd";

export const initialState = {
  loading: false,
  loadingAPKFAS1: false,
  loadingAPKFAS2: false,
  loadingApkas3: false,
  loadingApkas4: false,
  loadingApkas5: false,
  loadingSurfeyApka: false,
  loadingPosGeneral: false,
  loadingCustomer: false,
  message: "",
  showMessage: false,
  redirect: "",
  token: localStorage.getItem(AUTH_TOKEN) || null,
  result: {},
  productList: {},
  refreshList: false,
  getPageSize: "",
  getPageIndex: "",
  getCount: "",
  noApkFAS: "",
  APKFASList: [],
  APKFASItem: [],
  facilityDocItem: [],
  getEditApkFas2: [],
  getEditApkFas3: [],
  editBiaya: false,
  checkPercentage: {},
  customerList: {},
  statusRespon: 0,
  creditStepFacility: "",
};

export const getApkFasSlice = createAsyncThunk(
  "APKFAS1Slices/getApkFasSlice",
  async (userInput, { rejectWithValue }) => {
    try {
      const response = await APKFAS1SlicesService.getApkFasService(userInput);

      if (response.status === 200) {
        if (response && response.data) {
          return response.data;
        }
      } else {
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      notification.error({
        message: error.response.status,
        description: error.response.statusText,
        duration: 3,
      });
      return rejectWithValue(
        error.response?.data?.message || "Unexpected response!"
      );
    }
  }
);

export const getApkFasItemSlice = createAsyncThunk(
  "APKFAS1Slices/getApkFasItemSlice",
  async (userInput, { rejectWithValue }) => {
    try {
      const response = await APKFAS1SlicesService.getApkFasItemService(userInput);

      if (response.status === 200) {
        if (response && response.data) {
          return response.data;
        }
      } else {
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      notification.error({
        message: error.response.status,
        description: error.response.statusText,
        duration: 3,
      });
      return rejectWithValue(
        error.response?.data?.message || "Unexpected response!"
      );
    }
  }
);

export const getFacilityDocSlice = createAsyncThunk(
  "APKFAS1Slices/getFacilityDocSlice",
  async (userInput, { rejectWithValue }) => {
    try {
      const response = await APKFAS1SlicesService.getFacilityDoc(userInput);

      if (response.status === 200) {
        if (response && response.data) {
          return response.data;
        }
      } else {
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      notification.error({
        message: error.response.status,
        description: error.response.statusText,
        duration: 3,
      });
      return rejectWithValue(
        error.response?.data?.message || "Unexpected response!"
      );
    }
  }
);

export const posAPKFAS1Slices = createAsyncThunk(
  "APKFAS1Slices/posAPKFAS1Slices",
  async (userInput, { rejectWithValue }) => {
    try {
      const response = await APKFAS1SlicesService.posAPKFAS1Service(userInput);

      if (response.status === 200) {
        if (response.data.status == "Success") {
          notification.success({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        } else {
          notification.error({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        }
        return response.data;
      } else {
        //Selain Response 200
        console.log("Selain Response 200");
        notification.error({
          message: "Error",
          description: "Unexpected response!",
          duration: 3,
        });
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Unexpected response!"
      );
    }
  }
);

export const putAPKFAS1Sslice = createAsyncThunk(
  "APKFAS1Slices/putAPKFAS1Sslice",
  async (userInput, { rejectWithValue }) => {
    try {
      const response = await APKFAS1SlicesService.putAPKFAS1Service(userInput);

      if (response.status === 200) {
        if (response.data.status == "Success") {
          notification.success({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        } else {
          notification.error({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        }
        return response.data;
      } else {
        //Selain Response 200
        console.log("Selain Response 200");
        notification.error({
          message: "Error",
          description: "Unexpected response!",
          duration: 3,
        });
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Unexpected response!"
      );
    }
  }
);
// APKFAS2

export const getEditApkFas2Slice = createAsyncThunk(
  "APKFAS1Slices/getEditApkFas2Slice",
  async (userInput, { rejectWithValue }) => {
    try {
      const response = await APKFAS1SlicesService.getEditApkFas2Service(
        userInput
      );

      if (response.status === 200) {
        if (response && response.data) {
          return response.data;
        }
      } else {
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      notification.error({
        message: error.response.status,
        description: error.response.statusText,
        duration: 3,
      });
      return rejectWithValue(
        error.response?.data?.message || "Unexpected response!"
      );
    }
  }
);

export const posAPKFAS2Slices = createAsyncThunk(
  "APKFAS1Slices/posAPKFAS2Slices",
  async (userInput, { rejectWithValue }) => {
    try {
      const response = await APKFAS1SlicesService.posAPKFAS2Service(userInput);

      if (response.status === 200) {
        if (response.data.status == "Success") {
          notification.success({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        } else {
          notification.error({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        }
        return response.data;
      } else {
        //Selain Response 200
        console.log("Selain Response 200");
        notification.error({
          message: "Error",
          description: "Unexpected response!",
          duration: 3,
        });
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Unexpected response!"
      );
    }
  }
);

export const putAPKFAS2Slice = createAsyncThunk(
  "APKFAS1Slices/putAPKFAS2Slice",
  async (userInput, { rejectWithValue }) => {
    try {
      const response = await APKFAS1SlicesService.putAPKFAS2Service(userInput);

      if (response.status === 200) {
        if (response.data.status == "Success") {
          notification.success({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        } else {
          notification.error({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        }
        return response.data;
      } else {
        //Selain Response 200
        console.log("Selain Response 200");
        notification.error({
          message: "Error",
          description: "Unexpected response!",
          duration: 3,
        });
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Unexpected response!"
      );
    }
  }
);

// end APKFAS2
// APKFAS3

export const getEditApkFas3Slice = createAsyncThunk(
  "APKFAS1Slices/getEditApkFas3Slice",
  async (userInput, { rejectWithValue }) => {
    try {
      const response = await APKFAS1SlicesService.getEditApkFas3Service(
        userInput
      );

      if (response.status === 200) {
        if (response && response.data) {
          return response.data;
        }
      } else {
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      notification.error({
        message: error.response.status,
        description: error.response.statusText,
        duration: 3,
      });
      return rejectWithValue(
        error.response?.data?.message || "Unexpected response!"
      );
    }
  }
);

export const posAPKFAS3Slice = createAsyncThunk(
  "APKFAS1Slices/posAPKFAS3Slice",
  async (userInput, { rejectWithValue }) => {
    try {
      const response = await APKFAS1SlicesService.posAPKFAS3Service(userInput);

      if (response.status === 200) {
        if (response.data.status == "Success") {
          notification.success({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        } else {
          notification.error({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        }
        return response.data;
      } else {
        //Selain Response 200
        console.log("Selain Response 200");
        notification.error({
          message: "Error",
          description: "Unexpected response!",
          duration: 3,
        });
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Unexpected response!"
      );
    }
  }
);

// END APKFAS3

export const posAPKFAS5Slices = createAsyncThunk(
  "APKFAS1Slices/posAPKFAS5Slices",
  async (userInput, { rejectWithValue }) => {
    try {
      const response = await APKFAS1SlicesService.posAPKFAS5Service(userInput);

      if (response.status === 200) {
        if (response.data.status == "Success") {
          notification.success({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        } else {
          notification.error({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        }
        return response.data;
      } else {
        //Selain Response 200
        console.log("Selain Response 200");
        notification.error({
          message: "Error",
          description: "Unexpected response!",
          duration: 3,
        });
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Unexpected response!"
      );
    }
  }
);

export const posAPKFAS4Slice = createAsyncThunk(
  "APKFAS1Slices/posAPKFAS4Slice",
  async (userInput, { rejectWithValue }) => {
    try {
      const response = await APKFAS1SlicesService.posAPKFAS4Service(userInput);

      if (response.status === 200) {
        if (response.data.status == "Success") {
          notification.success({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        } else {
          notification.error({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        }
        return response.data;
      } else {
        //Selain Response 200
        console.log("Selain Response 200");
        notification.error({
          message: "Error",
          description: "Unexpected response!",
          duration: 3,
        });
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Unexpected response!"
      );
    }
  }
);

export const posCheckPercentageSlice = createAsyncThunk(
  "APKFAS1Slices/posCheckPercentageSlice",
  async (userInput, { rejectWithValue }) => {
    try {
      const response = await APKFAS1SlicesService.posCheckPercentageService(
        userInput
      );

      if (response.status === 200) {
        return response.data;
      } else {
        //Selain Response 200
        console.log("Selain Response 200");
        notification.error({
          message: "Error",
          description: "Unexpected response!",
          duration: 3,
        });
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Unexpected response!"
      );
    }
  }
);

export const posSurfeyAPKFASlice = createAsyncThunk(
  "APKFAS1Slices/posSurfeyAPKFASlice",
  async (userInput, { rejectWithValue }) => {
    try {
      const response = await APKFAS1SlicesService.posSurfeyAPKFAService(
        userInput
      );

      if (response.status === 200) {
        if (response.data.status == "Success") {
          notification.success({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        } else {
          notification.error({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        }
        return response.data;
      } else {
        //Selain Response 200
        console.log("Selain Response 200");
        notification.error({
          message: "Error",
          description: "Unexpected response!",
          duration: 3,
        });
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Unexpected response!"
      );
    }
  }
);

export const getCustomerSearchSlise = createAsyncThunk(
  "APKFAS1Slices/getCustomerSearchSlise",
  async (userInput, { rejectWithValue }) => {
    try {
      const response = await APKFAS1SlicesService.getCustomerSearchService(
        userInput
      );

      if (response.status === 200) {
        if (response && response.data) {
          return response.data;
        }
      } else {
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      notification.error({
        message: error.response.status,
        description: error.response.statusText,
        duration: 3,
      });
      return rejectWithValue(
        error.response?.data?.message || "Unexpected response!"
      );
    }
  }
);

export const getSurveyFacilitySlice = createAsyncThunk(
  "APKFAS1Slices/getSurveyFacilitySlice",
  async (userInput, { rejectWithValue }) => {
     console.log("useEffectparams ",userInput);
    try {
      const response = await APKFAS1SlicesService.getSurveyFacilityService(
        userInput
      );

      if (response.status === 200) {
        if (response && response.data) {
          return response.data;
        }
      } else {
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      notification.error({
        message: error.response.status,
        description: error.response.statusText,
        duration: 3,
      });
      return rejectWithValue(
        error.response?.data?.message || "Unexpected response!"
      );
    }
  }
);

export const APKFAS1Slices = createSlice({
  name: "apkFas1",
  initialState,
  reducers: {
    showNotification: (state, action) => {
      state.message = action.payload;
      state.showMessage = true;
      state.loading = false;
    },
    hideNotification: (state) => {
      state.message = "";
      state.showMessage = false;
    },
    showLoading: (state) => {
      state.loading = true;
    },
    setNullnoApkFAS: (state) => {
      // console.log("setNullnoApkFAS");

      state.noApkFAS = "";
      state.editBiaya = false;
      state.creditStepFacility = false;
      state.APKFASItem = [];
      state.facilityDocItem = [];
    },
    setNoApkFAS: (state, action) => {
      state.noApkFAS = action.payload;
    },
    setAPKFASItem: (state, action) => {
      state.APKFASItem = action.payload;
    },
    setCreditStepFacility: (state, action) => {
      state.creditStepFacility = action.payload;
    },
    setStatusResponReset: (state) => {
      state.statusRespon = 0;
    },
  },

  extraReducers: (builder) => {
    builder
      //getApkFasSlice
      .addCase(getApkFasSlice.pending, (state) => {
        state.loading = true;
        state.redirect = "";
      })
      .addCase(getApkFasSlice.fulfilled, (state, action) => {
        state.loading = false;
        state.APKFASList = action.payload;
        state.getCount = action.payload.count;
      })
      .addCase(getApkFasSlice.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
      })
      //getApkFasSlice
      .addCase(getApkFasItemSlice.pending, (state) => {
        state.loading = true;
        state.redirect = "";
      })
      .addCase(getApkFasItemSlice.fulfilled, (state, action) => {
        state.loading = false;
        state.APKFASItem = action.payload;
        state.getCount = action.payload.count;
      })
      .addCase(getApkFasItemSlice.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
      })
      // getFacilityDocSlice
      .addCase(getFacilityDocSlice.pending, (state) => {
        state.loading = true;
        state.redirect = "";
      })
      .addCase(getFacilityDocSlice.fulfilled, (state, action) => {
        state.loading = false;
        state.facilityDocItem = action.payload;
        state.getCount = action.payload.count;
      })
      .addCase(getFacilityDocSlice.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
      })
      //   pos
      .addCase(posAPKFAS1Slices.pending, (state) => {
        state.loadingAPKFAS1 = true;
        state.noApkFAS = "";
      })
      .addCase(posAPKFAS1Slices.fulfilled, (state, action) => {
        console.log("actionpostGuarantor", action);
        state.loadingAPKFAS1 = false;
        state.redirect = "/";
        state.result = action?.payload;
        state.showMessage = true;
        state.message = action?.payload?.message;
        state.noApkFAS = action?.payload?.message;
        state.refreshList = true;
        state.statusRespon = action?.payload?.status;
        state.creditStepFacility = "GN";
      })
      .addCase(posAPKFAS1Slices.rejected, (state, action) => {
        state.loadingAPKFAS1 = false;
        state.result = action.payload;
        state.showMessage = true;
        state.noApkFAS = "";
      })
      //   put
      .addCase(putAPKFAS1Sslice.pending, (state) => {
        state.loadingAPKFAS1 = true;
        // state.noApkFAS = "";
      })
      .addCase(putAPKFAS1Sslice.fulfilled, (state, action) => {
        console.log("actionpostGuarantor", action);
        state.loadingAPKFAS1 = false;
        state.redirect = "/";
        state.result = action?.payload;
        state.showMessage = true;
        state.message = action?.payload?.message;
        // state.noApkFAS = action?.payload?.message;
        state.refreshList = true;
        state.statusRespon = action?.payload?.status;
        state.creditStepFacility = "GN";
      })
      .addCase(putAPKFAS1Sslice.rejected, (state, action) => {
        state.loadingAPKFAS1 = false;
        state.result = action.payload;
        state.showMessage = true;
        // state.noApkFAS = "";
      })
      //   APKFAS2Slices
      // GET
      .addCase(getEditApkFas2Slice.pending, (state) => {
        state.loading = true;
        state.redirect = "";
      })
      .addCase(getEditApkFas2Slice.fulfilled, (state, action) => {
        state.loading = false;
        state.getEditApkFas2 = action.payload;
        state.getCount = action.payload.count;
      })
      .addCase(getEditApkFas2Slice.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
      })
      // post
      .addCase(posAPKFAS2Slices.pending, (state) => {
        state.loadingAPKFAS2 = true;
      })
      .addCase(posAPKFAS2Slices.fulfilled, (state, action) => {
        // console.log("actionpostGuarantor", action);
        state.loadingAPKFAS2 = false;
        state.redirect = "/";
        state.result = action?.payload;
        state.showMessage = true;
        state.message = action?.payload?.message;
        state.refreshList = true;
        state.statusRespon = action?.payload?.status;
        state.creditStepFacility = "PE";
      })
      .addCase(posAPKFAS2Slices.rejected, (state, action) => {
        state.loadingAPKFAS2 = false;
        state.result = action.payload;
        state.showMessage = true;
      })
      //   put
      .addCase(putAPKFAS2Slice.pending, (state) => {
        state.loadingAPKFAS2 = true;
      })
      .addCase(putAPKFAS2Slice.fulfilled, (state, action) => {
        // console.log("actionpostGuarantor", action);
        state.loadingAPKFAS2 = false;
        state.redirect = "/";
        state.result = action?.payload;
        state.showMessage = true;
        state.message = action?.payload?.message;
        state.refreshList = true;
        state.statusRespon = action?.payload?.status;
        state.creditStepFacility = "PE";
      })
      .addCase(putAPKFAS2Slice.rejected, (state, action) => {
        state.loadingAPKFAS2 = false;
        state.result = action.payload;
        state.showMessage = true;
      })
      //   posAPKFAS3Slice

      // END APKFAS2
      // APKFAS3
       // GET
      .addCase(getEditApkFas3Slice.pending, (state) => {
        state.loading = true;
        state.redirect = "";
      })
      .addCase(getEditApkFas3Slice.fulfilled, (state, action) => {
        state.loading = false;
        state.getEditApkFas3 = action.payload;
        state.getCount = action.payload.count;
      })
      .addCase(getEditApkFas3Slice.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
      })

      .addCase(posAPKFAS3Slice.pending, (state) => {
        state.loadingApkas3 = true;
      })
      .addCase(posAPKFAS3Slice.fulfilled, (state, action) => {
        console.log("actionpostGuarantor", action);
        state.loadingApkas3 = false;
        state.redirect = "/";
        state.result = action?.payload;
        state.showMessage = true;
        state.message = action?.payload?.message;
        state.refreshList = true;
        state.editBiaya = true;
        state.statusRespon = action?.payload?.status;
      })
      .addCase(posAPKFAS3Slice.rejected, (state, action) => {
        state.loadingApkas3 = false;
        state.result = action.payload;
        state.showMessage = true;
      })
      // END APKFAS3
      // APKFAS4
      //   posAPKFAS4Slice
      .addCase(posAPKFAS4Slice.pending, (state) => {
        state.loadingApkas4 = true;
      })
      .addCase(posAPKFAS4Slice.fulfilled, (state, action) => {
        console.log("posAPKFAS4Slice", action);
        state.loadingApkas4 = false;
        state.redirect = "/";
        state.result = action?.payload;
        state.showMessage = true;
        state.message = action?.payload?.message;
        state.refreshList = true;
        state.statusRespon = action?.payload?.status;
      })
      .addCase(posAPKFAS4Slice.rejected, (state, action) => {
        state.loadingApkas4 = false;
        state.result = action.payload;
        state.showMessage = true;
      })
      //   posCheckPercentageSlice
      .addCase(posCheckPercentageSlice.pending, (state) => {
        state.loadingApkas4 = true;
        state.checkPercentage = {};
      })
      .addCase(posCheckPercentageSlice.fulfilled, (state, action) => {
        // console.log("posCheckPercentageSliceposCheckPercentageSlice", action);
        state.loadingApkas4 = false;
        state.redirect = "/";
        state.checkPercentage = action?.payload;
        state.showMessage = true;
        state.message = action?.payload?.message;
        state.refreshList = true;
        state.statusRespon = 200;
      })
      .addCase(posCheckPercentageSlice.rejected, (state, action) => {
        state.loadingApkas4 = false;
        state.checkPercentage = {};
        state.showMessage = true;
      })
      //   posAPKFAS5Slices
      .addCase(posAPKFAS5Slices.pending, (state) => {
        state.loadingApkas5 = true;
      })
      .addCase(posAPKFAS5Slices.fulfilled, (state, action) => {
        console.log("actionpostGuarantor", action);
        state.loadingApkas5 = false;
        state.redirect = "/";
        state.result = action?.payload;
        state.showMessage = true;
        state.message = action?.payload?.message;
        state.refreshList = true;
        state.statusRespon = action?.payload?.status;
      })
      .addCase(posAPKFAS5Slices.rejected, (state, action) => {
        state.loadingApkas5 = false;
        state.result = action.payload;
        state.showMessage = true;
      })
      //   posAPKFAS5Slices
      .addCase(posSurfeyAPKFASlice.pending, (state) => {
        state.loadingSurfeyApka = true;
      })
      .addCase(posSurfeyAPKFASlice.fulfilled, (state, action) => {
        // console.log("actionpostGuarantor", action);
        state.loadingSurfeyApka = false;
        state.redirect = "/";
        state.result = action?.payload;
        state.showMessage = true;
        state.message = action?.payload?.message;
        state.refreshList = true;
        state.statusRespon = action?.payload?.status;
      })
      .addCase(posSurfeyAPKFASlice.rejected, (state, action) => {
        state.loadingSurfeyApka = false;
        state.result = action.payload;
        state.showMessage = true;
      })
      //getCustomerSearchSlise
      .addCase(getCustomerSearchSlise.pending, (state) => {
        state.loadingCustomer = true;
        state.redirect = "";
      })
      .addCase(getCustomerSearchSlise.fulfilled, (state, action) => {
        state.loadingCustomer = false;
        state.customerList = action.payload;
        state.getCount = action.payload.count;
      })
      .addCase(getCustomerSearchSlise.rejected, (state, action) => {
        state.loadingCustomer = false;
        state.result = action.payload;
        state.showMessage = true;
      })
      //getSurveyFacilitySlice
      .addCase(getSurveyFacilitySlice.pending, (state) => {
        state.loadingCustomer = true;
        state.redirect = "";
      })
      .addCase(getSurveyFacilitySlice.fulfilled, (state, action) => {
        state.loadingCustomer = false;
        state.customerList = action.payload;
        state.getCount = action.payload.count;
      })
      .addCase(getSurveyFacilitySlice.rejected, (state, action) => {
        state.loadingCustomer = false;
        state.result = action.payload;
        state.showMessage = true;
      });
  },
});

export const {
  //    update,
  showNotification,
  hideNotification,
  showLoading,
  setNullnoApkFAS,
  setStatusResponReset,
  setNoApkFAS,
  setCreditStepFacility,
  setAPKFASItem,
} = APKFAS1Slices.actions;

export default APKFAS1Slices.reducer;
